import { PaysafeInstance } from './paysafe-instance.interface';
import { PaysafeSetupOptions } from './paysafe-setup-options.interface';

export interface Paysafe {
  fields: {
    setup: (
      apiKey: string,
      options: PaysafeSetupOptions
    ) => Promise<PaysafeInstance>;
  };
}
